import { useState } from "react";
import {
  Box,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  IconButton,
  Chip,
  CircularProgress
} from '@mui/material';
import { Logout } from '@mui/icons-material';
import api from "../../../../helpers/api/LoginApi";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import UserTypes from "../../../../helpers/constants/UserTypes";
import { showStatus } from "../../../../helpers/api/errors/ShowStatus";

export default function ProfileButton() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const user = JSON.parse(localStorage.getItem("user"));
  const userType = UserTypes.filter((u) => u.type === user?.type);
  const [loading, setLoading] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    if (!loading) {
      setLoading(true);

      api.post(ApiUrls.auth.logout, {})
        .then((response) => {
          setLoading(false);
          if (response.data && response.data.status === "success") {
            localStorage.clear();
            window.location.href = "/sign-in";
          }
        })
        .catch((error) => {
          setLoading(false);
          showStatus("logout_error");
        });
    }
  }

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Avatar sx={{ width: 32, height: 32 }}><Avatar sx={{ backgroundColor: '#6c757db0' }} /></Avatar>
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem disabled className="profile-info">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>{user?.user}</div>
            <div className="user-type-chip">
              {user && userType
                ? <Chip label={userType[0].name} size="small" />
                : ""
              }
            </div>
          </div>
        </MenuItem>

        <Divider />

        <MenuItem onClick={logout}>
          {loading
            ? <CircularProgress color="secondary" size="1.5rem" className="ms-2" />
            : <Logout fontSize="small" sx={{ mr: 0.5 }} />
          }
          خروج
        </MenuItem>
      </Menu>
    </>
  );
}